import { makeAutoObservable, runInAction } from 'mobx';
import apiHandler from '../handlers/ApiHandler';

class RegistrationStore {
  registrations = [];
  loading = false;
  error = null;

  constructor() {
    makeAutoObservable(this);
  }

  fetchMine = async () => {
    this.loading = true;
    this.error = null;
    try {
      const response = await apiHandler.get('/registrations/mine');
      runInAction(() => {
        this.registrations = (response && response.registrations) || [];
      });
      return this.registrations;
    } catch (error) {
      runInAction(() => {
        this.error = error.message;
        console.error('Error fetching registered devices:', error);
      });
      return [];
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  clearError = () => {
    this.error = null;
  };
}

export default new RegistrationStore();
